import React, { Component, useRef } from "react";
import Switch from "react-switch";
import axios from "axios";
// import * as io from "socket.io-client";
import io from "socket.io-client";
import "../../styles/App.css";

///////////////////////////////////////////////////////////////////////////////////

// var mqtt = require("mqtt");
// var host = "ws://192.168.0.199:3000";
// var options = {
//   keepalive: 3600,
//   protocolId: "MQTT",
//   protocolVersion: 4,
//   clean: true,
//   reconnectPeriod: 1000,
//   connectTimeout: 30 * 1000,
//   will: {
//     topic: "WillMsg",
//     payload: "Connection Closed abnormally..!",
//     qos: 0,
//     retain: false,
//   },
//   username: "",
//   password: "",
//   rejectUnauthorized: false,
// };
// var mqttClient = mqtt.connect(host, options);

// const MQTT = require("async-mqtt");
// const client = MQTT.connect("tcp://192.168.0.199:3000");

////////////////////////////////////////////////////////////////////////////////////

class SwitchOnOff_boolean extends Component {
  constructor(props) {
    console.log(props.topic + " : " + props.message);
    super(props);
    this.state = {
      DefaultChecked: props.message,
      checked: "not yet",
      flag: "0",
      topic: props.topic,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
    // this.syncComponentDidMount = this.syncComponentDidMount.bind(this);
  }

  handleClick(checked) {
    if (this.state.flag == "0") {
      // if (this.state.DefaultChecked == true) {
      //   mqttClient.publish(
      //     "hamk/iot/valkeakoski/kontti/ui/" + this.state.topic + "/WriteOff",
      //     "false"
      //   );
      //   this.setState({ checked: false, flag: "1" });
      // }

      // if (this.state.DefaultChecked == false) {
      //   mqttClient.publish(
      //     "hamk/iot/valkeakoski/kontti/ui/" + this.state.topic + "/WriteOn",
      //     "true"
      //   );
      //   this.setState({ checked: true, flag: "1" });
      // }
    }
    if (this.state.flag == "1") {
      return;
    }
  }

  handleChange(checked) {
    if (this.state.flag == "1") {
      // if (this.state.checked == true) {
      //   mqttClient.publish(
      //     "hamk/iot/valkeakoski/kontti/ui/" + this.state.topic + "/WriteOff",
      //     "false"
      //   );
      //   this.setState({ checked: false, flag: "1" });
      // }

      // if (this.state.checked == false) {
      //   mqttClient.publish(
      //     "hamk/iot/valkeakoski/kontti/ui/" + this.state.topic + "/WriteOn",
      //     "true"
      //   );
      //   this.setState({ checked: true, flag: "1" });
      // }
    }
    if (this.state.flag == "0") {
      return;
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.message !== this.props.message) {
      this.setState({ DefaultChecked: this.props.message });
    }
  }

  componentWillMount() {}
  componentDidMount() {}

  render() {
    return (
      <label>
        <div onClick={this.handleClick}>
          <Switch
            onChange={this.handleChange}
            checked={
              this.state.checked == "not yet"
                ? this.state.DefaultChecked
                : this.state.checked
            }
            offColor={this.props.topic !== "Fan" ? "#0000FF" : "#B8860B"}
            onColor={this.props.topic !== "Fan" ? "#DC143C" : "#F4A460"}
            width={40}
            height={20}
          />
        </div>
      </label>
    );
  }
}

export default SwitchOnOff_boolean;
